import types from '../types'

const initialState = {
  /* Default values here */
  theme: 'dark',
  lang: 'eng',
  isSignedIn: false,
  isFirebaseSignedIn: false,
  isMFANeeded: false,
  selectedModuleKey: 'claims',
  taskId: 'car_demo_v2',
  tools: {},
}

export default function(state = initialState, action) {
  switch (action.type) {
    case types.STORE_PAYLOAD:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
